// extracted by mini-css-extract-plugin
export default {"column":"InputGrid_column__SdHLE","label":"InputGrid_label__J3Sau","input":"InputGrid_input__bNttI","row":"InputGrid_row__5FcBb"};